(function (angular) {
    'use strict';

    angular.module('chat2')
        /**
         *
         */
        .controller('startChatCtrl', ["$scope", "$stateParams", "$state", "jwtService", "teamSettingsService", "chatAdminService", "customChannelService", "participantProfile", "growlService", "rcsServices", "$q",
            function ($scope, $stateParams, $state, jwtService, teamSettingsService, chatAdminService, customChannelService, participantProfile, growlService, rcsServices, $q) {

                $scope.chatId = undefined;
                $scope.selectedChannelId = undefined;
                $scope.profileId = participantProfile.profile.generalProperties.properties.id.value;


                // make a list of all teams the user is a member of ...
                $scope.teamsUserIsMemberOf = [];

                $scope.channels = [{
                    name: "SMS",
                    id: "sms"
                }, {
                    name: "Messenger",
                    id: "fbMessenger"
                }, {
                    name: "App Messaging",
                    id: "appMessaging"
                }, {
                    name: "Email",
                    id: "email"
                }, {
                    name: "Twitter",
                    id: "twitterDm"
                }, {
                    name: "WhatsApp",
                    id: "whatsApp"
                }, {
                    name: "RCS",
                    id: "rcs"
                }];


                // is the logged in agent in more than one team ?
                // no, just use their teamId
                // yes, ask then to pick the team they ant to start the chat in ...                
                teamSettingsService.getTeams($stateParams.pickedApiSpaceId)
                    .then(function (teams) {
                        var profileId = jwtService.payload.sub;

                        angular.forEach(teams, function (team) {
                            angular.forEach(team.members, function (member) {
                                if (member.username === profileId) {
                                    $scope.teamsUserIsMemberOf.push({
                                        id: team.id,
                                        name: team.name
                                    });
                                }
                            });
                        });

                        return teamSettingsService.getChatConfig($stateParams.pickedApiSpaceId);
                    })
                    .then(function (config) {
                        angular.forEach(config.teams, function (team) {

                            var item = $scope.teamsUserIsMemberOf.find(function (t) {
                                return t.id === team.teamId;
                            });

                            if (item) {
                                item.channels = team.channels;
                            }
                        });

                        // strip out any that dont have any channels

                        for (var i = $scope.teamsUserIsMemberOf.length - 1; i >= 0; i--) {
                            if ($scope.teamsUserIsMemberOf[i].channels === undefined) {
                                $scope.teamsUserIsMemberOf.splice(i, 1);
                            }
                        }

                        return customChannelService.getChannels($stateParams.pickedApiSpaceId);
                    })
                    .then(function (channels) {

                        function checkIfAnyPropertyExist(idFieldNames, propertyGroup) {
                            for (var fieldNameIndex in idFieldNames) {
                                var idFieldName = idFieldNames[fieldNameIndex];
                                if (propertyGroup.properties[idFieldName] && propertyGroup.properties[idFieldName].value) {
                                    return true;
                                }
                            }
                            return false;
                        }

                        var rcsChannel = channels.find((el) => { return el.id == 'rcs' });
                        var promise;
                        if (rcsChannel) {
                            $scope.rcsAgent;
                            $scope.currentTeam = $scope.teamsUserIsMemberOf[0];
                            if ($scope.currentTeam.channels.rcs) {
                                $scope.rcsAgentId = $scope.currentTeam.channels.rcs.agentId;
                                promise = rcsServices.getRcsAgent($stateParams.pickedApiSpaceId, $scope.rcsAgentId)
                                    .then((agent) => {
                                        $scope.rcsAgent = agent;
                                        return $q.resolve();
                                    })
                            } else {
                                promise = $q.resolve();
                            }
                        } else {
                            promise = $q.resolve();
                        }
                        promise.then(() => {
                            angular.forEach(channels, function (channel) {

                                channel.canSend = false;

                                if (channel.id === "appMessaging") {
                                    channel.canSend = participantProfile._devices !== undefined && participantProfile._devices.length > 0;
                                } else if (channel.id === "twitterDm") {
                                    channel.canSend = participantProfile.profile.twitter && checkIfAnyPropertyExist(channel.idFieldNames, participantProfile.profile.twitter)
                                } else if (channel.id === "fbMessenger") {
                                    channel.canSend = checkIfAnyPropertyExist(channel.idFieldNames, participantProfile.profile.facebook)
                                } else if (channel.id === "rcs" && $scope.rcsAgent) {
                                    if (checkIfAnyPropertyExist(channel.idFieldNames, participantProfile.profile.generalProperties)) {
                                        if ($scope.rcsAgent.status == 'launched') {
                                            channel.canSend = true;
                                        }
                                        else {
                                            for (var i in participantProfile.profile.rcs.properties.agents.value) {
                                                if (i == $scope.rcsAgentId && participantProfile.profile.rcs.properties.agents.value[i] == 'active') {
                                                    channel.canSend = true;
                                                }
                                            }
                                        }
                                    }
                                } else {
                                    channel.canSend = checkIfAnyPropertyExist(channel.idFieldNames, participantProfile.profile.generalProperties)
                                }

                                var ch = $scope.channels.find(function (c) {
                                    return c.id === channel.id;
                                });

                                if (ch) {
                                    ch.canSend = channel.canSend;
                                }
                            });
                            if ($scope.teamsUserIsMemberOf.length > 0) {
                                $scope.setCurrentTeam($scope.teamsUserIsMemberOf[0]);
                            }
                        })
                    })
                    .catch(function (error) {
                        console.error(error);
                    });

                /**
                 * 
                 */
                $scope.selectChannel = function (channel) {
                    if ($scope.profileSupportsChannel(channel)) {
                        $scope.selectedChannelId = channel.id;
                    }
                }

                /**
                 * 
                 */
                $scope.setCurrentTeam = function (team) {

                    $scope.currentTeam = team;
                    $scope.selectedChannelId = undefined;

                    $scope.availableChannels = [];
                    angular.forEach($scope.channels, function (channel) {
                        if ($scope.isChannelAvailable(channel) &&
                            $scope.profileSupportsChannel(channel)) {
                            $scope.availableChannels.push(channel);
                        }
                    });

                }

                /**
                 * 
                 */
                $scope.profileSupportsChannel = function (channel) {
                    return channel.canSend;
                }

                /**
                 * Channel has to be setup in the currentTeam
                 */
                $scope.isChannelAvailable = function (channel) {
                    return $scope.currentTeam && $scope.currentTeam.channels && $scope.currentTeam.channels[channel.id] !== undefined;
                }

                /**
                 * 
                 */
                $scope.createChat = function () {

                    chatAdminService.create($stateParams.pickedApiSpaceId,
                        "Chat with " + $stateParams.profileId,
                        "Chat created from UI",
                        $scope.currentTeam.id,
                        $scope.selectedChannelId,
                        $stateParams.profileId)
                        .then(function (chat) {
                            $scope.chatId = chat.id;
                        })
                        .catch(function (error) {
                            var message = "Failed to create chat."

                            if (error && error.data && error.data.validationFailures && error.data.validationFailures.length > 0) {
                                message = error.data.validationFailures[0].message;
                            }

                            growlService.danger(message);
                        });
                }

                /**
                 * We can't navigate to the conversation until it is in the chat store.
                 * Chat store will broadcast conversationCreated events 
                 *  - we store the conversation Id returned from chatAdminService.create() above and compare and then make the transition ...
                 */
                $scope.$on('MemoryConversationStore.conversationCreated', function (event, data) {

                    if (data.id === $scope.chatId) {
                        $state.go("main.apiSpace.chat2.chat.conversation", {
                            pickedApiSpaceId: $stateParams.pickedApiSpaceId,
                            id: $scope.chatId
                        });
                        $scope.chatId = undefined;
                    }
                });

            }]);

})(window.angular);
